import styled from 'styled-components';
import {PrimaryLink} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

export const RoomDetailsHeaderWrap = styled.div(
  props => `
  display:flex;
  position:sticky;
  top:0;
  border-bottom: 1px solid  ${props.theme.colors.goBrandBlue.light};
  background-color: ${props.theme.colors.goWhite.base};
  margin-bottom:${props.theme.spacing.large};
  justify-content: space-between;
  align-items: center;
  padding-bottom: ${props.theme.spacing.large};
  z-index: ${props.theme.misc.zIndex.small};
  padding: ${props.theme.spacing.xlarge};
  border-radius: ${props.theme.misc.borderRadius.custom(17)};
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  `,
);
export const RoomAmenitiesBodyWrap = styled.div(
  props => `
    padding: 0;
    `,
);
export const HouseRulesList = styled.li(
  props => `
    padding: 3.4rem 2.5rem 0.5rem;
    list-style: none;
`,
);
export const IconWrap = styled.span(props => `margin-top:0.2rem;`);
export const PolicyListHeading = styled.p(
  props => `
    font-size: ${props.theme.font.custom(18)};
    margin-bottom: ${props.theme.spacing.base};
    font-weight:700;
    color:rgba(70, 72, 77, 1)
    `,
);
export const ListPara = styled.p(
  props => `
    font-size: ${props.theme.font.custom(16)};
    width:95%;
    `,
);
export const FeatureListUL = styled.ul(
  props => `
      display:flex;
      flex-direction: column;
      li{
        display:flex;
        margin-bottom: 1rem;
        padding:0 !important;
        align-items: flex-start;
      }
      `,
);
export const MorePolicyLink = styled(PrimaryLink)(
  props => `
    font-size: ${props.theme.font.custom(16)};
    font-weight: 600;
    padding:${props.theme.spacing.base} ${props.theme.spacing.xxlarge}; 
    `,
);
